import React, { useState } from 'react'
import { Button, message, Modal, Space, Tag } from 'antd'
import { ITaxYear } from './types'
import './style.less'
import { LinkOutlined } from '@ant-design/icons'
import { APIFunctions } from '../../lib/apiFunctions'

export default function ShareModal({
    taxYear,
    visible,
    setVisible,
    apiFunctions,
}: {
    taxYear: ITaxYear
    visible: boolean
    apiFunctions: APIFunctions
    setVisible: (isV: boolean) => void
}) {
    const [loading, setLoading] = useState<boolean>(false)
    const [sharingLink, setSharingLink] = useState<string>(null)

    const handleCancel = () => {
        setVisible(false)
    }

    function copyToClipboard(e) {
        navigator.clipboard.writeText(sharingLink)
        message.success('link copied!')
    }

    async function getSharingLink() {
        setLoading(true)
        try {
            const res = await apiFunctions.shareTaxYear(taxYear.id)
            setSharingLink(res?.report_link)
        } catch (ex) {
            console.log(ex)
        }
        setLoading(false)
    }

    return (
        <>
            <Modal
                visible={visible}
                title={'Share Compliance Report'}
                footer={[<Button onClick={handleCancel}>Return</Button>]}
                onCancel={handleCancel}
            >
                <p>
                    You can share this compliance report by link.
                    <br />
                    Anyone with this link can view this report.
                </p>
                {!sharingLink && (
                    <Button onClick={getSharingLink} icon={<LinkOutlined />} loading={loading}>
                        Get sharing link
                    </Button>
                )}

                {!!sharingLink && (
                    <Space direction="horizontal">
                        <Button size="small" onClick={copyToClipboard}>Copy</Button>
                        <Tag style={{overflow: 'scroll', maxWidth: '80%'}} color="processing">{sharingLink}</Tag>
                    </Space>
                )}
            </Modal>
        </>
    )
}
